import React, { FC, useContext, useEffect } from 'react';
import { useCommon } from '../../../../../contexts/CommonContext';
import DailyEngagedUsersContext from '../../../../../contexts/DailyEngagedUsersContext';
import { useContentLocalizer } from '../../../../../hooks/useContentLocalizer';
import DailyEngagedUserMonthlyUsage from '../../../DailyEngagedUsers/components/DailyEngagedUserMonthlyUsage';
import { localizationDailyEngagedUsers } from '../../localization';
import { DailyEngagedUserContainer } from '../../styles';

const MonthlyUsageComponent: FC = () => {
  const { dateToSearch, tenant } = useContext(DailyEngagedUsersContext);
  const { setHeaderContent } = useCommon();
  const content = useContentLocalizer(localizationDailyEngagedUsers);

  useEffect(() => {
    setHeaderContent({
      redirect: '/deu-consumption',
      text: content.formatString(content.header, tenant.info.name),
    });

    return () => setHeaderContent({ redirect: null });
  }, [dateToSearch]);

  return (
    <DailyEngagedUserContainer>
      <DailyEngagedUserMonthlyUsage isDetailedView />
    </DailyEngagedUserContainer>
  );
};

export default MonthlyUsageComponent;
